<template>
    <div>
        <loading
            :active.sync="isLoading"
            :can-cancel="true"
            loader="dots"
            :is-full-page="fullPage"
            :height="height"
            :width="width"
            background-color="#6b6969"
        ></loading>
        <div class="container" id="contentItem">
            <div class="row text-center">
                <div class="col-lg-8 offset-lg-2 col-sm-6 offset-sm-3 col-12 p-3 error-main">
                    <div class="row">
                        <div class="col-lg-8 col-12 col-sm-10 offset-lg-2 offset-sm-1">
                            <div class="card card-login">
                                <form @submit.prevent="submit()" style="min-height: 320px;">
                                    <div class="card-header card-header-primary text-center">
                                        <h4 class="card-title">Talent Portal Login</h4>
                                    </div>
                                    <!--<router-link to="/sign-up" class="description text-center text-dark">Or Sign Up</router-link>-->
                                    <br>
                                    <div class="card-body">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons text-dark">mail</i>
                        </span>
                                            </div>
                                            <input
                                                type="email"
                                                required
                                                v-model="data.email"
                                                class="form-control"
                                                placeholder="Email..."
                                            />
                                        </div>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="material-icons text-dark">lock_outline</i>
                        </span>
                                            </div>
                                            <input
                                                type="password"
                                                required
                                                v-model="data.password"
                                                class="form-control"
                                                placeholder="Password..."
                                            />
                                        </div>
                                    </div>
                                    <div class="footer text-center mt-3 mb-3">
                                        <button type="submit" class="btn btn-green btn-wd">Submit</button>
                                    </div>
                                    <div class="text-center mb-3">
                                        <router-link to="/" class="text-muted">Go to home</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import Swal from "sweetalert2";
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";
    import axios from "axios";

    export default {
        data() {
            return {
                data: {
                    email: "",
                    password: ""
                },
                isLoading: false,
                fullPage: true,
                details: {},
                height: 128,
                width: 128,

            };
        },
        components: {
            Loading
        },
        methods: {
            submit() {
                this.isLoading = true;
                this.$store
                    .dispatch("retrieveToken", this.data)
                    .then((res) => {
                        if (res.info.type == 'intern') {
                            if (this.$store.state.redirectPathLink !== null) {
                                this.$router.push((this.$store.state.redirectPathLink.path.fullPath));
                            } else {
                                this.$router.push('/internship');
                            }
                        } else {
                            Swal.fire({
                                title: "Error!",
                                text: "Sorry this session is for interns only. Please contact GhanaTech lab's administration.",
                                icon: "error",
                                confirmButtonText: "Close"
                            });
                        }
                    })
                    .catch(err => {
                        console.log((err))
                        Swal.fire({
                            title: "Error!",
                            text: "Email/Password does not exist",
                            icon: "error",
                            confirmButtonText: "Close"
                        });
                    }).finally(() => {
                    this.isLoading = false;
                });
            }
        },
        created() {
            document.title = 'Login || Employability Portal';
        }
    };
</script>


<style scoped>

    #contentItem {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>
